<div class="panel panel-default application-card">
  <div class="panel-heading clearfix">
    <h4 class="panel-title pull-left">{{ cardTitle }}</h4>
  </div>
  <div class="panel-body">
    <p class="application-description" style="white-space: pre-line;">{{ cardDescription }}</p>

    <div *ngFor="let application of applications" class="application-entry">
      <span class="label" [ngClass]="statusBadgeClass(application.status)">
        {{ statusLabel(application.status) }}
      </span>
      <span *ngIf="application.status === 'draft'" class="submission-date text-muted">
        <i class="fa fa-pencil-square-o"></i>
        Draft saved on {{ application.updated_at | date:'d MMM yyyy' }}
      </span>
      <span *ngIf="application.status !== 'draft'" class="submission-date text-muted">
        <i class="fa fa-check-circle-o"></i>
        Submitted on {{ application.created_at | date:'d MMM yyyy' }}
      </span>
      <button *ngIf="application.status === 'draft'"
              class="btn btn-warning btn-sm" (click)="onEdit(application)">
        <i class="fa fa-pencil"></i>&nbsp; Continue Application
      </button>
      <button *ngIf="application.status !== 'draft'"
              class="btn btn-info btn-sm" (click)="onView(application)">
        <i class="fa fa-eye"></i>&nbsp; View Application
      </button>
    </div>
  </div>
  <div class="panel-footer text-right" *ngIf="canApply">
    <button class="btn btn-primary" (click)="onApply()">
      Apply Now &nbsp;<i class="fa fa-arrow-right"></i>
    </button>
  </div>
</div>
